import React, { useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import { useCloudCtx } from "../../controllers/cloud";
import image from "../../assets/img/default-avatar.png";
import PerfectScrollbar from "perfect-scrollbar";

const Lecturers = () => {
  let ps;
  const cloudCtx = useCloudCtx();

  const lecturers = cloudCtx.lecturers;

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      if (document.getElementById("lecturers")) {
        ps = new PerfectScrollbar("#lecturers");
      }
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return function cleanup() {
      if (
        document.getElementById("lecturers") &&
        navigator.platform.indexOf("Win") > -1
      ) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  });

  return (
    <section className="pt-4 pb-1 position-relative bg-gray-100">
      <div className="container mt-2">
        <div className="mb-3">
          <h2 className="">Our Esteem Facilitators</h2>
        </div>
        <div className="lecturers" id="lecturers">
          {lecturers &&
            lecturers.map((lecturer) => {
              return (
                <Card
                  className="card-profile lecturer-item mx-3 moving-card"
                  key={lecturer.id}
                >
                  <a href="#paul" className="p-3 pb-0">
                    <div className="lecturer-img-wrapper border-radius-md">
                      <img
                        className="w-100"
                        src={
                          lecturer.imageUrl
                            ? lecturer.imageUrl.imageUrlDecode()
                            : image
                        }
                        alt="Lecturers"
                      />
                    </div>
                  </a>

                  <CardBody className="p-3">
                    <h5
                      className="mb-0"
                      style={{ fontSize: "1.15rem", lineHeight: "1.2rem" }}
                    >
                      {`${lecturer.surname} ${lecturer.first} ${
                        lecturer.other ?? ""
                      }`.trim()}
                    </h5>
                  </CardBody>
                </Card>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default Lecturers;
